import React, { useState, useEffect, Fragment } from "react";
import "../Scss/LibraryStyles.scss?v=1.1.3";
import api from "../../api/axios";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  Autocomplete,
  ButtonGroup,
  Button,
  CircularProgress,
  LinearProgress,
  Chip,
  Fade,
} from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

const Crear = () => {
  const { goPanel, goTable } = useLocationHelpers();

  const [libraryCompany, setLibraryCompany] = useState("");
  // const [libraryOffice, setLibraryOffice] = useState("");
  const [libraryTitle, setLibraryTitle] = useState("");
  const [libraryProcessType, setLibraryProcessType] = useState("");
  const [libraryTags, setLibraryTags] = useState([]); // Cambiado de "" a []
  const [libraryDescription, setLibraryDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [newTag, setNewTag] = useState(""); // Estado para nuevo tag

  const [optionsCompany, setOptionsCompany] = useState([]);
  // const [optionsOffices, setOptionsOffices] = useState([]);
  const [optionsTypes, setOptionsTypes] = useState([]);
  const [loadingOptionsCompany, setLoadingOptionsCompany] = useState(false);
  // const [loadingOptionsOffices, setLoadingOptionsOffices] = useState(false);
  // const [optionsOfficesOriginal, setOptionsOfficesOriginal] = useState([]);
  const [loadingOptionsTypes, setLoadingOptionsTypes] = useState(false);
  const [optionsTypesOriginal, setOptionsTypesOriginal] = useState([]);

  const [flag, setFlag] = useState(false);

  const navigate = useNavigate();

  const getData = async () => {
    setFlag(true);
    const url = `${process.env.REACT_APP_API_URL}/library/create`;
    try {
      const response = await api.post(url);
      setOptionsCompany([
        { company_name: "Seleccionar", id: 0 },
        ...response.data.companies,
      ]);

      // setOptionsOfficesOriginal(response.data.offices);
      setOptionsTypesOriginal(response.data.cases_type);

      // setOptionsOffices([
      //   { office_name: "Seleccionar", id: 0 },
      //   ...response.data.offices,
      // ]);
      setOptionsTypes([
        { case_type: "Seleccionar", id: 0 },
        ...response.data.cases_type,
      ]);
      setFlag(false);
    } catch (error) {
      console.error("Error al cargar datos:", error);
    } finally {
      setFlag(false);
    }
  };

  const handleLibrarysFormInformation = async () => {
    const isValid = validateFields();
    console.log(selectedFile);

    if (!isValid) {
      showValidationErrors();
      return;
    }

    if (!selectedFile) {
      alert("Por favor selecciona un archivo");
      return;
    }

    const formData = new FormData();
    formData.append("company_id", libraryCompany?.id);
    formData.append("file", selectedFile); // Archivo PDF
    formData.append("title", libraryTitle);
    // formData.append("office_id", libraryOffice?.id);
    formData.append("type", libraryProcessType?.case_type);
    formData.append("tags", libraryTags);
    formData.append(
      "description",
      libraryDescription?.replace(/\n/g, "<br />"),
    );

    const queryUrl = `${process.env.REACT_APP_API_URL}/library/store`;

    const resultSwal = await Swal.fire({
      title: "¿Desea guardar los cambios?",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      confirmButtonText: "Continuar",
      denyButtonText: "Volver",
      reverseButtons: true,
    });

    if (!resultSwal.isConfirmed) {
      Swal.fire("¡Los cambios no han sido guardados!", "", "info");
      return;
    }

    try {
      const response = await api.post(queryUrl, formData, {
        // withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data", // Importante para enviar archivos
        },
      });

      if (response.data.error) {
        Swal.fire({
          title: "¡No se guardaron los cambios!",
          icon: "error",
          text: "Por favor inténtelo nuevamente",
          confirmButtonColor: "#1ab394",
        });
      } else {
        const nextAction = await Swal.fire({
          title: "¡Guardado!",
          icon: "success",
          html: `¿Seguir creando?`,
          showDenyButton: true,
          reverseButtons: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#1ab394",
        });

        if (nextAction.isDenied) {
          navigate("/biblioteca");
        }
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error en el servidor",
        icon: "error",
        text: "No se pudo guardar el archivo",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  const validateFields = () => {
    const fields = [
      // { value: libraryOffice, name: "Despacho" }, //
      { value: libraryTitle, name: "Título" },
      { value: libraryProcessType, name: "Tipo de Proceso" }, //
      { value: libraryTags, name: "Etiquetas" },
      { value: libraryDescription, name: "Descripción" },
    ];

    console.log(fields);

    return fields.every((field) => {
      if (field.value == null && field.value == "undefined") {
        console.log("entra");
        return false; // El campo es null o undefined
      }

      if (field.value) {
        return field.value !== ""; // Verificamos que la cadena no esté vacía después de trim
      }
    });
  };

  const showValidationErrors = () => {
    const fields = [
      { value: libraryCompany, name: "Empresa" },
      // { value: libraryOffice, name: "Despacho" },
      { value: libraryTitle, name: "Título" },
      { value: libraryProcessType, name: "Tipo de Proceso" },
      { value: libraryTags, name: "Etiquetas" },
      { value: libraryDescription, name: "Descripción" },
    ];

    const missingFields = fields
      .filter((field) => field.value === "" || field.value === 0)
      .map((field) => `<li>${field.name}</li>`)
      .join("");

    Swal.fire({
      title: "¡Error!",
      icon: "error",
      html: `<div style="text-align: start;">Por favor rellene los campos: <ul >${missingFields}</ul></div>`,
      confirmButtonColor: "#1ab394",
      toast: false,
    });
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const InputFileUpload = ({ text }) => (
    <Button
      component="label"
      startIcon={<CloudUploadIcon />}
      sx={{
        border: "dotted",
        height: "100px",
        "& .MuiSvgIcon-root": { fontSize: "25px !important" },
      }}>
      {text}
      {/* Asegúrate de usar onChange en el input */}
      <VisuallyHiddenInput type="file" onChange={handleFileChange} />
    </Button>
  );

  const handleFileChange = (event) => {
    const files = event.target.files;
    console.log(files[0]);
    if (files.length > 0 && files[0].type == "application/pdf") {
      setSelectedFile(files[0]);
      console.log("Archivo seleccionado:", files[0]);
    } else {
      Swal.fire({
        title: "¡Error!",
        text: "Solo se permite formato PDF",
        icon: "error",
        confirmButtonColor: "#1ab394",
        toast: false, // Asegúrate de que el toast esté en 'false', ya que los toasts son notificaciones flotantes.
      });
    }
  };

  const handleAddTag = () => {
    if (newTag && !libraryTags.includes(newTag.trim())) {
      setLibraryTags([...libraryTags, newTag.trim()]);
    }
    setNewTag(""); // Limpia el campo de texto después de agregar
  };

  const handleDeleteTag = (tagToDelete) => {
    setLibraryTags(libraryTags.filter((tag) => tag !== tagToDelete));
  };

  const inputFields = [
    {
      label: "Empresa",
      key: "companyId",
      options: optionsCompany,
      loading: loadingOptionsCompany,
      setFilter: (value) => {
        setLibraryCompany(value);
        // filterOfficesByCompany(value?.id || 0);
        filterProcessTypesByCompany(value?.id || 0);
      },
      handleOpen: () => setLoadingOptionsCompany(true),
      handleClose: () => setLoadingOptionsCompany(false),
      isOptionEqualToValue: (option, value) =>
        option.company_name === value.company_name,
      getOptionLabel: (option) => option.company_name,
      defaultValue: { company_name: "Seleccionar" },
      type: "autocomplete",
      value: libraryCompany || null,
    },
    // {
    //   label: "Despacho",
    //   key: "officeId",
    //   options: optionsOffices,
    //   loading: loadingOptionsOffices,
    //   setFilter: (value) => setLibraryOffice(value),
    //   handleOpen: () => setLoadingOptionsOffices(true),
    //   handleClose: () => setLoadingOptionsOffices(false),
    //   isOptionEqualToValue: (option, value) =>
    //     option.office_name === value.office_name,
    //   getOptionLabel: (option) => option.office_name,
    //   defaultValue: { office_name: "Seleccionar" },
    //   type: "autocomplete",
    //   value: libraryOffice || null,
    // },
    {
      label: "Título",
      key: "titleId",
      type: "text",
      setFilter: (value) => setLibraryTitle(value),
    },
    {
      label: "Tipo de proceso",
      key: "processTypeId",
      options: optionsTypes,
      loading: loadingOptionsTypes,
      setFilter: (value) => setLibraryProcessType(value),
      handleOpen: () => setLoadingOptionsTypes(true),
      handleClose: () => setLoadingOptionsTypes(false),
      isOptionEqualToValue: (option, value) =>
        option.case_type === value.case_type,
      getOptionLabel: (option) => option.case_type,
      defaultValue: { case_type: "Seleccionar tipo de Proceso" },
      type: "autocomplete",
      value: libraryProcessType || null,
    },
    {
      label: "Etiquetas",
      key: "tagsId",
      type: "tags", // Nuevo tipo para etiquetas
    },
    {
      label: "Descripción",
      key: "description",
      type: "textarea",
      setFilter: (value) => setLibraryDescription(value),
      value: libraryDescription,
    },
  ];

  useEffect(() => {
    getData();
  }, []);

  // Función para filtrar despachos según empresa
  // const filterOfficesByCompany = (companyId) => {
  //   if (!companyId || companyId === 0) {
  //     setOptionsOffices([{ office_name: "Seleccionar", id: 0 }]);
  //     setLibraryOffice({ office_name: "Seleccionar", id: 0 });
  //     return;
  //   }

  //   const filtered = optionsOfficesOriginal.filter(
  //     (office) => office.company_id === companyId,
  //   );

  //   setOptionsOffices([{ office_name: "Seleccionar", id: 0 }, ...filtered]);
  //   setLibraryOffice({ office_name: "Seleccionar", id: 0 });
  // };

  // Función para filtrar tipos de proceso según empresa
  const filterProcessTypesByCompany = (companyId) => {
    if (!companyId || companyId === 0) {
      setOptionsTypes([{ case_type: "Seleccionar", id: 0 }]);
      setLibraryProcessType({ case_type: "Seleccionar", id: 0 }); // Reinicia selección
      return;
    }

    const filtered = optionsTypesOriginal.filter(
      (type) => type.company_id === companyId,
    );

    setOptionsTypes([{ case_type: "Seleccionar", id: 0 }, ...filtered]);
    setLibraryProcessType({ case_type: "Seleccionar", id: 0 }); // Reinicia selección
  };

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Biblioteca" subTitle="Crear" />

      {flag && <LoadingPage isLoading={flag} heightProp={"60vh"} />}

      {!flag && (
        <Fade timeout={600} in={!flag}>
          <Box
            component="form"
            sx={{ margin: "auto", "& > :not(style)": {} }}
            noValidate
            autoComplete="off"
            className="formMainContainer">
            <Grid
              container
              style={{ textAlign: "center" }}
              p={2}
              className="fontSize">
              {inputFields.map((field) => (
                <Grid
                  item
                  xs={12}
                  md={6}
                  key={field.key}
                  sx={{ padding: "5px" }}>
                  {field.type === "tags" ? (
                    <div>
                      {/* Campo para añadir nuevos tags */}
                      <FormControl style={{ width: "100%" }}>
                        <TextField
                          label="Nuevo tag"
                          variant="outlined"
                          size="small"
                          value={newTag}
                          onChange={(e) => setNewTag(e.target.value)}
                        />
                        <Button
                          onClick={handleAddTag}
                          color="success"
                          variant="outlined">
                          Añadir Tag
                        </Button>
                      </FormControl>
                      {/* Muestra los tags como chips */}
                      <div style={{ marginTop: "10px" }}>
                        {libraryTags.map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag.toUpperCase()}
                            size="small"
                            variant="outlined"
                            onDelete={() => handleDeleteTag(tag)}
                            style={{ margin: 4 }}
                          />
                        ))}
                      </div>
                    </div>
                  ) : field.type === "autocomplete" ? (
                    <FormControl className="inputFormCreate">
                      <Autocomplete
                        id={field.key}
                        className="selectWithInput"
                        value={field.value} // Utiliza el valor actual para vincular la selección
                        size="small"
                        onChange={(event, value) => field.setFilter(value)}
                        open={field.loading}
                        onOpen={field.handleOpen}
                        onClose={field.handleClose}
                        isOptionEqualToValue={field.isOptionEqualToValue}
                        getOptionLabel={field.getOptionLabel}
                        options={field.options}
                        loading={field.loading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={field.label}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <Fragment>
                                  {field.loading && (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  )}
                                  {params.InputProps.endAdornment}
                                </Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  ) : field.type === "textarea" ? (
                    <FormControl style={{ width: "100%" }}>
                      <FormLabel sx={{ textAlign: "left" }}>
                        {field.label}
                      </FormLabel>
                      <textarea
                        style={{
                          height: "100px",
                          resize: "none",
                          padding: "6px 13px",
                          fontSize: "15px",
                          borderRadius: "4px",
                          border: "1px solid rgba(128, 128, 128, 0.35)",
                        }}
                        onChange={(event) =>
                          field.setFilter(event.target.value)
                        }
                        value={field.value}
                      />
                    </FormControl>
                  ) : (
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        value={field.value}
                        label={field.label}
                        onChange={(e) => field.setFilter(e.target.value)}
                        size="small"
                      />
                    </FormControl>
                  )}
                </Grid>
              ))}

              <Grid
                item
                xs={12}
                container
                justifyContent="center"
                alignItems="center">
                <Grid item xs={12} paddingTop={2}>
                  <InputFileUpload text={"FICHERO (PDF)"} />
                </Grid>
                <Grid item xs={12} paddingTop={1}>
                  {selectedFile.name
                    ? "Archivo seleccionado: " + selectedFile.name
                    : ""}
                </Grid>
              </Grid>
              <ButtonGroup
                sx={{
                  width: "100%",
                  justifyContent: "center",
                  textAlign: "center",
                  margin: "20px auto 0px auto",
                }}>
                <Button
                  sx={{ width: "100%" }}
                  onClick={handleLibrarysFormInformation}
                  variant="outlined"
                  color="success">
                  Guardar
                </Button>
                <Button
                  sx={{ width: "100%" }}
                  onClick={() => goTable("biblioteca", "Biblioteca")}
                  variant="outlined"
                  color="error">
                  Tabla
                </Button>
                <Button
                  sx={{ width: "100%" }}
                  onClick={goPanel}
                  variant="outlined">
                  Inicio
                </Button>
              </ButtonGroup>
            </Grid>
          </Box>
        </Fade>
      )}
    </div>
  );
};

export default Crear;
